Confirm = require 'views/lib/confirm'
SelectMemberView = require 'views/member/select-member-view'

module.exports = class ConfirmAddEmail extends Confirm
  constructor: ->
    super
    @template = 'confirm_merge'

  render: ->
    super
    @appendSubview @subview(SelectMemberView, @model), @$('.js-member')
    @



// WEBPACK FOOTER //
// ./app/scripts/views/header/confirm-add-email.coffee